import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'analyse-';

export default {
    path: '/analyse',
    name: 'analyse',
    redirect: {
        name: `${pre}analyse`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'enterprise',
            name: `${pre}enterprise`,
            meta: {
                ...meta,
                title: '企业分析',
                closable: false
            },
            component: () => import('@/pages/economy/analyse/enterprise')
        },{
            path: 'fund',
            name: `${pre}fund`,
            meta: {
                ...meta,
                title: '回收分析',
                closable: false
            },
            props: true,
            component: () => import('@/pages/economy/analyse/fund')
        }
        ,{
            path: 'reclaim',
            name: `${pre}reclaim`,
            meta: {
                ...meta,
                title: '资金分析',
                closable: false
            },
            component: () => import('@/pages/economy/analyse/reclaim')
        }
    ]
};
